import React from "react";
import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { ReeferCheckType } from "__generated__/graphql";
import { intl } from "LocaleWrapper";

const ReeferCheckTypeSelect = ({ value, onChange }: Omit<SelectProps<ReeferCheckType, false>, "fetchOptions">) => {
	return (
		<Select
			fetchOptions={Object.values(ReeferCheckType)}
			getOptionLabel={option => intl.formatMessage({ id: option })}
			value={value}
			onChange={onChange}
			disableSearch />
	);
};

export default ReeferCheckTypeSelect;
